export interface Authenticate {
  access_token: string;
  expires_in: number;
  ext_expires_in: number;
  token_type: string;
}

export interface Slot {
  timestamp: number;
  text: string;
  available: string;
}

export interface SlotsApiResponse {
  status: boolean;
  message: string;
  data: Slot[];
}

export const reservationPayload = {
  resourceId: '',
  startTime: '',
  endTime: '',
  quantity: 1,
  email: '',
  firstName: '',
  lastName: '',
  address: '',
  city: '',
  zip: '',
  state: '',
  country: '',
  phonePrefix: '',
  phoneNumber: '',
  mobilePrefix: '',
  mobileNumber: '',
  sapOutboundId: null,
  language: '',
  unitIds: '',
  icimUserId: '',
  sendNotifications: false,
};
